import { render, staticRenderFns } from "./oftenSystem.vue?vue&type=template&id=9d064526&scoped=true&"
import script from "./oftenSystem.vue?vue&type=script&lang=js&"
export * from "./oftenSystem.vue?vue&type=script&lang=js&"
import style0 from "./oftenSystem.vue?vue&type=style&index=0&id=9d064526&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d064526",
  null
  
)

export default component.exports